'use client'

import { Container } from '@/ui/layouts/container/Container'
import { BaseSkeleton } from '@/ui/skeleton/BaseSkeleton'
import { ButtonSkeleton } from '@/ui/skeleton/ButtonSkeleton.client'
import { TextSkeleton } from '@/ui/skeleton/TextSkeleton'

export function HeaderSkeleton(): React.ReactElement {
  return (
    <Container className="pb-3 pt-4">
      <TextSkeleton className="w-[20.625rem] desktop:text-4xl" size="3xl" leading="normal" />

      <div className="relative">
        <ButtonSkeleton
          className="absolute left-0 top-1/2 z-base hidden -translate-x-1/2 -translate-y-1/2 desktop:block"
          size="md"
          isRound
        />
        <ButtonSkeleton
          className="absolute right-0 top-1/2 z-base hidden -translate-y-1/2 translate-x-1/2 desktop:block"
          size="md"
          isRound
        />
        <div className="mt-3 flex gap-1 overflow-hidden">
          {Array.from({ length: 9 }, (_, index) => (
            <BaseSkeleton key={index} className="h-15 w-20 shrink-0" />
          ))}
        </div>
      </div>
    </Container>
  )
}
